import React from "react";
import banner from "../Images/bg_img.webp"; 
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

import './TermsPrivacy.css'; // Reuse the CSS from Terms & Privacy Policy

const CancellationRefundPolicy = () => {
  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <section className="terms-banner">
        <img src={banner} alt="Cancellation & Refund Policy" className="banner-image" />
        <div className="banner-overlay">
          <h1>Cancellation & Refund Policy</h1>
          <p>Guidelines & Policies of Sri Ashtothara Shatha (108) Chukkala Charitable Trust</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content">
        <div className="terms-container">
          <h2>Cancellation and Refund Policy</h2>

          <h3>1. Donations are Non-Refundable</h3>
          <p>
            All donations made to Sri Ashtothara Shatha (108) Chukkala’s Charitable Trust (SASCCT) 
            through our website are final and non-refundable.
          </p>

          <h3>2. Duplicate Transactions</h3>
          <p>
            If a donor makes a duplicate payment by mistake, they may request a refund within 
            <strong> 7 days </strong> of the transaction by contacting us at 
            <a href="mailto:seva@sascct.org"> seva@sascct.org </a>.
          </p>

          <h3>3. Transaction Failures or Errors</h3>
          <p>
            In case of any technical issue resulting in a failed transaction but debited amount, 
            donors are requested to contact their bank first. If the issue persists, they can reach 
            out to us for assistance.
          </p>

          <h3>4. Contact Details</h3>
          <p>
            For refund-related queries, please contact:
            <br />
            Email: <a href="mailto:seva@sascct.org">seva@sascct.org</a> (mention "Refund request" in the subject)
          </p>

          <h3>5. Processing Time</h3>
          <p>
            Approved refunds (for duplicate or erroneous transactions) will be credited within 
            <strong> 7–10 business days</strong>.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CancellationRefundPolicy;
